var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordVoiceOverRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7213_39031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2707 19.5559C19.3104 19.1883 20.0553 18.1966 20.0553 17.031C20.0553 15.5523 18.8565 14.3535 17.3778 14.3535C15.8991 14.3535 14.7004 15.5523 14.7004 17.031C14.7004 18.1969 15.4456 19.1888 16.4858 19.5562V24.2358H10.7092C7.94781 24.2358 5.70923 26.4744 5.70923 29.2358V39.0005C5.70923 41.7619 7.94781 44.0005 10.7092 44.0005H24.1798C26.9412 44.0005 29.1798 41.7619 29.1798 39.0005V37.8241H31.8824C32.4346 37.8241 32.8824 37.3764 32.8824 36.8241V31.4123C32.8824 30.8601 32.4346 30.4123 31.8824 30.4123H29.1798V29.2358C29.1798 26.4744 26.9412 24.2358 24.1798 24.2358H18.2707V19.5559ZM11.1371 36.6659C12.6159 36.6659 13.8146 35.4672 13.8146 33.9885C13.8146 32.5097 12.6159 31.311 11.1371 31.311C9.65843 31.311 8.45969 32.5097 8.45969 33.9885C8.45969 35.4672 9.65843 36.6659 11.1371 36.6659ZM25.4148 33.9885C25.4148 35.4672 24.216 36.6659 22.7373 36.6659C21.2586 36.6659 20.0599 35.4672 20.0599 33.9885C20.0599 32.5097 21.2586 31.311 22.7373 31.311C24.216 31.311 25.4148 32.5097 25.4148 33.9885ZM2 31.4123C2 30.8601 2.44772 30.4123 3 30.4123H5.70588V37.8241H3C2.44772 37.8241 2 37.3764 2 36.8241V31.4123Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1524 26.7422C34.59 23.7708 32.299 21.4797 29.3275 20.9174L29.206 15.9777C35.3969 16.3753 39.964 20.9424 40.0921 26.8638L35.1524 26.7422Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0246 10.9781L28.9212 6.19993C40.5925 6.65756 49.6524 15.7462 49.8848 27.1636L45.1067 27.0602C44.317 18.3263 37.5188 11.5281 29.0246 10.9781Z",
    fill: "#0A0A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7213_39031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordVoiceOverRobot);
export default __webpack_public_path__ + "static/media/RecordVoiceOverRobot.2ecd3de643e03e56158269d966754aa8.svg";
export { ForwardRef as ReactComponent };